(() => {
  const revenueStops = [0, 10000, 25000, 50000, 100000, 250000, 500000, 1000000, 2500000, 5000000, 10000000, 25000000, 50000000];
  const currencies = {US:'USD', GB:'GBP', AU:'AUD', CA:'CAD', CH:'CHF', BR:'BRL', MX:'MXN', NZ:'NZD', SE:'SEK', DK:'DKK', NO:'NOK', PL:'PLN', SG:'SGD', JP:'JPY', IN:'INR', ZA:'ZAR'};
  const marketRanges = ['1', '2-3', '4-7', '8-15', '16+'];
  const productRanges = ['1-50', '51-100', '101-250', '251-500', '501-1000', '1000+'];
  function routeForRevenue(value, threshold = 50000) { return Number(value) < Number(threshold) ? 'video' : 'calendar'; }
  function routeForLead(value, marketRange, threshold = 50000) { return marketRange === '1' ? 'video' : routeForRevenue(value, threshold); }
  function videoLanguageForLocale(locale) { return /^es(?:[-_]|$)/i.test(locale || '') ? 'es' : 'en'; }
  function normalizeStore(value) {
    try {
      const url = new URL(/^https?:\/\//i.test(value.trim()) ? value.trim() : `https://${value.trim()}`);
      if (!['http:', 'https:'].includes(url.protocol) || !url.hostname.includes('.') || url.username || url.password) return null;
      return url.href;
    } catch { return null; }
  }
  const model = {revenueStops, routeForRevenue, routeForLead, videoLanguageForLocale, normalizeStore, marketRanges, productRanges};
  if (typeof module !== 'undefined' && module.exports) module.exports = model;
  if (typeof window === 'undefined' || customElements.get('geosort-demo')) return;

  class GeosortDemo extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const on = (el, name, cb, options = {}) => el.addEventListener(name, cb, {...options, signal:this.controller.signal});
      this.dialog = this.querySelector('dialog');
      this.form = this.querySelector('#GeosortDemoContact');
      this.newsletter = this.querySelector('#GeosortDemoNewsletter');
      this.messages = JSON.parse(this.querySelector('[data-demo-messages]').textContent);
      Object.keys(this.messages).forEach(key => { this.messages[key] = new DOMParser().parseFromString(this.messages[key], 'text/html').body.textContent; });
      try { this.rates = JSON.parse(this.querySelector('[data-demo-rates]').textContent); } catch { this.rates = {EUR:1}; }
      this.slider = this.querySelector('[data-demo-revenue]');
      this.currency = this.querySelector('[data-demo-currency]');
      this.submit = this.querySelector('[data-demo-submit]');
      this.error = this.querySelector('[data-demo-error]');
      this.intake = this.querySelector('[data-demo-intake]');
      this.results = this.querySelector('[data-demo-results]');
      // Shopify wraps these submit callbacks with its own CAPTCHA protection.
      // Install before the first interaction, then use captcha.protect to submit.
      this.form.submit = () => this.postForm('contact');
      this.newsletter.submit = () => this.postForm('newsletter');
      this.locale = navigator.language || this.dataset.locale || 'en';
      this.marketCount = this.querySelector('[data-demo-market-count]');
      on(this.marketCount, 'change', () => this.marketCount.setCustomValidity(''));
      on(this.querySelector('[data-demo-consent]'), 'change', () => { this.consentChanged = true; });
      const videoLanguage = videoLanguageForLocale(this.dataset.locale);
      const videoTemplate = this.querySelector(`[data-demo-video-template="${videoLanguage}"]`) || this.querySelector('[data-demo-video-template="en"]');
      this.querySelector('[data-demo-video-mount]').append(videoTemplate.content.cloneNode(true));
      let region = this.dataset.country;
      try { region = new Intl.Locale(this.locale).region || region; } catch { /* Keep Shopify's country. */ }
      this.currency.value = currencies[region] || 'EUR';
      [...this.currency.options].forEach(option => { if (!(Number(this.rates[option.value]) > 0)) option.remove(); });
      if (!this.currency.value) this.currency.value = 'EUR';
      this.receiptUrl = new URL(this.dataset.receiptUrl, location.origin);
      const preview = new URLSearchParams(location.search).get('preview_theme_id');
      if (preview) this.receiptUrl.searchParams.set('preview_theme_id', preview);
      [this.form, this.newsletter].forEach(form => {
        const url = new URL(this.receiptUrl);
        url.searchParams.set(form === this.form ? 'contact_posted' : 'customer_posted', 'true');
        form.elements.return_to.value = url.pathname + url.search;
      });
      this.renderRevenue();
      on(this.slider, 'input', () => this.renderRevenue());
      on(this.currency, 'change', () => this.renderRevenue());
      on(this.form.elements['contact[Store URL]'], 'input', event => event.target.setCustomValidity(''));
      on(this.form.querySelector('[data-demo-products]'), 'change', event => event.target.setCustomValidity(''));
      on(document, 'click', event => {
        const trigger = event.target.closest('a[href], [data-open-geosort-demo]');
        if (!trigger) return;
        const href = trigger.getAttribute('href') || '';
        if (!trigger.hasAttribute('data-open-geosort-demo') && href !== '#get-demo') return;
        event.preventDefault();
        this.source = trigger.closest('section')?.id || trigger.closest('geosort-dock')?.id || 'website';
        document.querySelectorAll('geosort-dock').forEach(dock => { if (typeof dock.close === 'function') dock.close(false); });
        this.open(trigger);
      });
      on(this.querySelector('[data-demo-close]'), 'click', () => this.close());
      on(this.dialog, 'cancel', event => { event.preventDefault(); this.close(); });
      on(this.dialog, 'click', event => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.close();
      });
      on(this.form, 'submit', event => this.prepareContact(event));
      this.querySelectorAll('[data-demo-expand]').forEach(button => on(button, 'click', () => {
        const option = button.closest('[data-demo-option]');
        const expanded = button.getAttribute('aria-expanded') !== 'true';
        button.setAttribute('aria-expanded', String(expanded));
        option.classList.toggle('is-open', expanded);
        option.querySelector('.gsdemo-option-content').inert = !expanded;
        if (expanded) this.loadMedia(option.dataset.demoOption);
        else if (option.dataset.demoOption === 'video') this.stopVideo();
      }));
      if (location.hash === '#get-demo') this.open();
      on(window, 'hashchange', () => { if (location.hash === '#get-demo') this.open(); });
      if (this.dataset.editorPreview && this.dataset.editorPreview !== 'closed') {
        if (['video','calendar'].includes(this.dataset.editorPreview)) {
          this.route = this.dataset.editorPreview;
          this.showResults();
        }
        this.open();
      }
    }
    disconnectedCallback() {
      this.controller?.abort(); this.controller = null;
      clearTimeout(this.contactTimer); clearTimeout(this.newsletterTimer); clearTimeout(this.closeTimer);
      this.stopVideo();
      if (this.dialog?.open) { this.dialog.close(); document.documentElement.classList.remove('gsdemo-lock'); }
    }
    open(trigger) {
      this.returnFocus = trigger || document.activeElement;
      clearTimeout(this.closeTimer);
      this.dialog.classList.remove('is-closing');
      if (!this.dialog.open) this.dialog.showModal();
      document.documentElement.classList.add('gsdemo-lock');
      if (!this.results.hidden) this.querySelectorAll('[data-demo-option].is-open').forEach(option => this.loadMedia(option.dataset.demoOption));
      (this.results.hidden ? this.querySelector('#gsdemo-title') : this.querySelector('[data-demo-result-title]')).focus({preventScroll:true});
    }
    close() {
      this.dialog.classList.add('is-closing');
      this.stopVideo();
      this.closeTimer = setTimeout(() => {
        this.dialog.close();
        document.documentElement.classList.remove('gsdemo-lock');
        this.returnFocus?.focus({preventScroll:true});
      }, matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 180);
    }
    stopVideo() {
      this.querySelectorAll('video').forEach(video => video.pause());
      this.querySelectorAll('[data-demo-video-src]').forEach(frame => frame.removeAttribute('src'));
    }
    money(value) {
      return new Intl.NumberFormat(this.locale, {style:'currency', currency:this.currency.value, maximumFractionDigits:0}).format(value * this.rates[this.currency.value]);
    }
    renderRevenue() {
      this.revenue = revenueStops[Number(this.slider.value)];
      const output = this.money(this.revenue) + (this.revenue === revenueStops.at(-1) ? '+' : '');
      this.querySelector('[data-demo-revenue-output]').textContent = output;
      this.slider.setAttribute('aria-valuetext', output);
      this.slider.style.setProperty('--gsdemo-progress', `${Number(this.slider.value) / Number(this.slider.max) * 100}%`);
      this.querySelector('[data-demo-range-min]').textContent = this.money(0);
      this.querySelector('[data-demo-range-max]').textContent = this.money(revenueStops.at(-1)) + '+';
    }
    prepareContact(event) {
      event.preventDefault();
      event.stopImmediatePropagation();
      if (this.contactPending || this.contactSent) { event.preventDefault(); return; }
      if (!marketRanges.includes(this.marketCount.value)) {
        this.marketCount.setCustomValidity(this.messages.markets_required);
        this.marketCount.reportValidity();
        this.marketCount.focus();
        return;
      }
      const urlInput = this.form.elements['contact[Store URL]'];
      const storeUrl = normalizeStore(urlInput.value);
      if (!storeUrl) { event.preventDefault(); urlInput.setCustomValidity(this.messages.invalid_url); urlInput.reportValidity(); return; }
      const productInput = this.form.querySelector('[data-demo-products]');
      const products = productInput.value;
      if (!productRanges.includes(products)) { productInput.setCustomValidity(this.messages.products_required); productInput.reportValidity(); productInput.focus(); return; }
      urlInput.value = storeUrl;
      this.route = routeForLead(this.revenue, this.marketCount.value, Number(this.dataset.threshold) || 50000);
      if (this.hasAttribute('data-editor-preview')) { this.showResults(); return; }
      this.consent = this.querySelector('[data-demo-consent]').checked;
      this.querySelector('[data-demo-revenue-summary]').value = `${this.querySelector('[data-demo-revenue-output]').textContent} (${this.currency.value})`;
      this.querySelector('[data-demo-revenue-eur]').value = String(this.revenue);
      this.querySelector('[data-demo-route]').value = this.route === 'video' ? 'Watch demo first' : 'Book with Marc first';
      this.querySelector('[data-demo-source]').value = `${location.origin}${location.pathname} | ${this.source || 'website'}`;
      const consentRecord = this.consent ? (this.consentChanged ? 'Selected - product tips and updates' : 'Preselected checkbox retained - product tips and updates') : 'No';
      this.querySelector('[data-demo-consent-value]').value = consentRecord;
      this.querySelector('[data-demo-body]').value = `Demo request\nStore: ${storeUrl}\nAnnual revenue: ${this.querySelector('[data-demo-revenue-summary]').value}\nRevenue EUR equivalent: ${this.revenue}\nNumber of countries (range): ${this.marketCount.value}\nProducts (range): ${products}\nDemo priority: ${this.route}\nMarketing preference: ${consentRecord}`;
      this.error.hidden = true;
      this.contactPending = true;
      this.submit.disabled = true;
      this.submit.firstChild.textContent = this.messages.sending;
      this.contactTimer = setTimeout(() => this.fail('contact'), 90000);
      this.protectedSubmit(this.form);
    }
    protectedSubmit(form) {
      if (window.Shopify?.captcha?.protect) window.Shopify.captcha.protect(form, () => form.submit());
      else form.submit();
    }
    async postForm(kind) {
      if (!this[`${kind}Pending`] || this[`${kind}Posting`]) return;
      this[`${kind}Posting`] = true;
      const form = kind === 'contact' ? this.form : this.newsletter;
      try {
        const response = await fetch(form.action, {method:'POST',body:new URLSearchParams(new FormData(form)),credentials:'same-origin',signal:AbortSignal.timeout(60000)});
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        if (new URL(response.url).pathname.includes('/challenge') || doc.querySelector('form[action*="/challenge"]')) {
          this.fail(kind);
          if (kind === 'contact') {
            const challenge = this.querySelector('[data-demo-challenge]');
            challenge.href = response.url;
            this.querySelector('[data-demo-verification]').hidden = false;
          }
          return;
        }
        if (!response.ok) { this.fail(kind); return; }
        this.receive(kind, doc);
      } catch { this.fail(kind); }
      finally { this[`${kind}Posting`] = false; }
    }
    receive(kind, doc) {
      if (!this[`${kind}Pending`]) return;
      const receipt = doc.querySelector(`[data-demo-receipt="${kind}"]`);
      if (!receipt || receipt.dataset.status !== 'success') { this.fail(kind); return; }
      clearTimeout(this[`${kind}Timer`]);
      this.querySelector('[data-demo-verification]').hidden = true;
      this[`${kind}Pending`] = false;
      this[`${kind}Sent`] = true;
      if (kind === 'contact') { this.showResults(); if (this.consent) this.subscribe(); }
      else this.subscriptionStatus('confirmed');
    }
    fail(kind) {
      clearTimeout(this[`${kind}Timer`]);
      this[`${kind}Pending`] = false;
      if (kind === 'contact') {
        this.error.textContent = this.messages.error; this.error.hidden = false;
        this.submit.disabled = false; this.submit.firstChild.textContent = this.messages.continue;
      } else {
        // Newsletter status never changes a confirmed demo request into an error.
        // The contact email retains the preference for follow-up if Shopify cannot confirm it.
        this.subscriptionStatus('unconfirmed');
      }
    }
    subscriptionStatus(status) {
      this.dataset.subscriptionStatus = status;
      this.dispatchEvent(new CustomEvent('geosort:demo-subscription', {bubbles:true,detail:{status}}));
      if (status === 'unconfirmed') console.warn('[Geosort demo] Newsletter subscription unconfirmed; demo request saved.');
    }
    subscribe() {
      if (!this.consent || this.newsletterPending || this.newsletterSent) return;
      this.newsletterPending = true;
      this.subscriptionStatus('pending');
      this.newsletter.elements['contact[email]'].value = this.form.elements['contact[email]'].value;
      this.newsletter.elements['contact[first_name]'].value = this.form.elements['contact[name]'].value;
      this.newsletterTimer = setTimeout(() => this.fail('newsletter'), 90000);
      this.protectedSubmit(this.newsletter);
    }
    showResults() {
      this.intake.hidden = true; this.results.hidden = false;
      this.dialog.setAttribute('aria-labelledby', 'gsdemo-result-title');
      const options = this.querySelector('[data-demo-options]');
      const primary = options.querySelector(`[data-demo-option="${this.route}"]`);
      options.prepend(primary);
      options.querySelectorAll('[data-demo-option]').forEach(option => {
        const active = option === primary;
        option.classList.toggle('is-primary', active); option.classList.toggle('is-open', active);
        option.querySelector('[data-demo-expand]').setAttribute('aria-expanded', String(active));
        option.querySelector('.gsdemo-option-content').inert = !active;
      });
      this.loadMedia(this.route);
      this.dialog.scrollTop = 0;
      this.querySelector('[data-demo-result-title]').focus({preventScroll:true});
    }
    loadMedia(kind) {
      if (kind === 'calendar') {
        const frame = this.querySelector('[data-demo-calendar]');
        if (!frame.hasAttribute('src')) {
          const url = new URL(this.dataset.calendar);
          url.searchParams.set('gv', 'true'); url.searchParams.set('hl', this.dataset.locale || 'en');
          frame.src = url.href;
        }
      } else {
        this.querySelectorAll('[data-demo-video-src]').forEach(frame => { if (!frame.hasAttribute('src')) frame.src = frame.dataset.demoVideoSrc; });
      }
    }
  }
  customElements.define('geosort-demo', GeosortDemo);
})();
